import { AdminApiService } from '../services';
import type { LlmTestModelRequest } from '../services';

export const getLlmDefaultModel = () => {
  return AdminApiService.getLlmDefaultModelApiAdminLlmDefaultModelGet();
};

type TestLlmModelOptions = {
  model: string;
  // LLM model params (temperature, max_tokens, reasoning_effort, ...) so the
  // probe exercises the same config the prompt would carry.
  params?: Record<string, any> | null;
  // Override the campaign's provider; omitted, the campaign's provider is used.
  provider?: string | null;
  // Scope the probe to a campaign so its provider + key are used (instead of
  // the system key).
  campaignId?: string | null;
};

export const testLlmModel = ({
  model,
  params,
  provider,
  campaignId,
}: TestLlmModelOptions) => {
  const body: LlmTestModelRequest = { model };
  if (params) body.params = params;
  if (provider) body.provider = provider;
  return AdminApiService.testLlmModelApiAdminLlmTestModelPost(
    body,
    campaignId ?? undefined
  );
};
